export const routeSart = /^\//;
